import React from 'react';
import Breadcrumb from '../../../components/section/Breadcrumb';
import CategorySectionListLeftSide from '../section/CategorySectionListLeftSide';
import FooterSection from '../section/FooterSection';
import HeaderSection from '../section/HeaderSection';
import OptionSection from '../section/OptionSection';
import SubscribeSection from '../section/SubscribeSection';

export default function CategoryPageListLeftBar() {
    return (
        <>
            <HeaderSection />
            <Breadcrumb title="Category" />
            <CategorySectionListLeftSide />
            <SubscribeSection />
            <OptionSection />
            <FooterSection />
        </>
    );
}
